import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  redirect,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import {supabase} from "./components/supabaseClient"
import Root from "./routes/root"
import SignIn from "./routes/sign_in"

const checkSignIn = async () => {
  console.log("Check Sign In...")
  const session_data = await supabase.auth.getSession()
  console.log(session_data)
  if(session_data.data.session === null){
    return redirect("/sign_in")

  }
  return session_data.data.session
}


const router = createBrowserRouter([
  {
    path: "/",
    loader: checkSignIn,
    element: <Root />,
  },
  {
    path: "/sign_in",
    element: <SignIn />,
  },
]);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
